import $axios from '~/plugins/axios';

import { Api, CampaignAdditionalMaterialDistribution, CampaignAdditionalMaterialDistributions } from '~/api';
import { buildModule } from '../utils';
import { Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedDistributions: {} as Dict<CampaignAdditionalMaterialDistribution[]>,
		loading: false,
	})
	.withGetters({
		byAdditionalMaterialId: state => (additionalMaterialId: number) => (
			state.storedDistributions[additionalMaterialId] ?? []
		),
		loading: state => state.loading,
	})
	.withMutations({
		STORE_DISTRIBUTIONS (state, [ additionalMaterialId, distributions ]: [number, CampaignAdditionalMaterialDistributions]) {
			state.storedDistributions = {
				...state.storedDistributions,
				[additionalMaterialId]: distributions.additionalMaterialDistributions,
			};
		},
		SET_LOADING (state, loading: boolean) {
			state.loading = loading;
		},
	})
	.withActions({
		async get ({ commit }, additionalMaterialId: number) {
			commit('SET_LOADING', true);
			const { data } = await api.get(`/campaign-additional-material/${ additionalMaterialId }/distribution`);
			commit('SET_LOADING', false);

			commit('STORE_DISTRIBUTIONS', [ additionalMaterialId, data.payload ]);
		},
	});
